import { get, post, put, destroy } from "./base";

const UserServ = {
    // Profile
    getProfile: () => get("/users/profile"),
    updateProfile: (payload) => put("/users/profile", payload),
    uploadProfileImage: (formData) => {
        return post("/users/profile/upload", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
    uploadImage: (formData) => post("/upload/image", formData),

    // Seller request
    requestSeller: (payload) => post("/users/request-seller", payload),
    cancelSellerRequest: () => destroy("/users/cancel-seller-request"),

    // Dashboard Stats
    getBuyerStats: (params) => get("/users/buyer-stats", { params }),
    getSellerStats: (params) => get("/users/seller-stats", { params }),

    // Offers
    getOffers: () => get("/users/offers"),

    // Security
    getSecuritySettings: () => get("/users/security-settings"),
    changePassword: (payload) => put("/users/profile/change-password", payload),
    updatePrivacy: (payload) => put("/users/profile/privacy", payload),
    updateNotifications: (payload) => put("/users/profile/notifications", payload),

    // Notifications
    getNotifications: (params) => get("/users/notifications", { params }),
    markNotificationRead: (id) => put(`/users/notifications/${id}/read`),
    markAllNotificationsRead: () => put("/users/notifications/read-all"),

    // Legacy/admin-style endpoints (if needed)
    index: (params) => get("/users", { params }),
    single: (id) => get(`/users/${id}`),
    create: (payload) => post(`/users`, payload),
    update: (id, payload) => put(`/users/${id}`, payload),
    remove: (id) => destroy(`/users/${id}`),

};

export default UserServ;
